import React from "react";

function EmployeeTravel({ chart_data }) {
  const data = Array.isArray(chart_data) ? chart_data : [];
  if (!data.length) {
    return <div className="text-muted">No Data Available</div>;
  }

  return (
    <>
      {data.map((emp, index) => (
        <div key={emp.id} className="shadow-none mb-2">
            <div className="border border-dashed bg-transparent-light rounded p-2 mb-2">
                <div className="d-flex align-items-center w-100">
                <span className="d-block border border-2 h-12 rounded-5 me-2 border-primary"></span>
                <div className="d-flex justify-content-between align-items-center w-100">
                    <span className="fs-13 text-muted">
                    {emp.employee_name}
                    </span>

                    <span className="fs-13 text-muted">
                     Travelling
                    </span>
                </div>
                </div>
            </div>
            </div>
        ))}
    </>
  );
}

export default EmployeeTravel;